export class PollingTool {
  private timeouts = new Map<string, ReturnType<typeof setTimeout>>();
  private pollActions = new Map<string, () => void>();
  private readonly defaultPollingInterval: number;

  constructor(defaultInterval: number) {
    this.defaultPollingInterval = defaultInterval;
  }

  public add(key: string, pollAction: () => void, interval?: number): void {
    if (this.timeouts.has(key)) {
      return;
    }
    this.pollActions.set(key, pollAction);
    this.schedule(key, pollAction, interval ?? this.defaultPollingInterval);
  }

  public reschedule(key: string, pollAction?: () => void, interval?: number): void {
    const action = pollAction ?? this.pollActions.get(key);
    if (!action) {
      return;
    }

    this.remove(key);
    this.pollActions.set(key, action);
    this.schedule(key, action, interval ?? this.defaultPollingInterval);
  }

  public remove(key: string): void {
    const timeout = this.timeouts.get(key);
    if (timeout) {
      clearTimeout(timeout);
      this.timeouts.delete(key);
    }
    this.pollActions.delete(key);
  }

  private schedule(key: string, pollAction: () => void, interval: number): void {
    const timeout = setTimeout(() => {
      this.timeouts.delete(key);
      pollAction();
    }, interval);
    this.timeouts.set(key, timeout);
  }
}
